export default __webpack_public_path__ + "locales/el-GR/DataReassignmentDialog.json?hash=1bff247a2b787b0c861b2ee58029bafb";